import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Degraded assessment model: one row per turn whose expression assessment failed
 * even after retries, recording the error tag that forced the degrade so the
 * hole in the record is queryable rather than invisible.
 * @since 1.0.0
 */
export class DegradedAssessment extends Model.Class<DegradedAssessment>("DegradedAssessment")({
  id: Model.Generated(Schema.String),
  conversationId: Schema.String,
  messageId: Schema.String,
  errorTag: Schema.String,
  createdAt: Model.DateTimeInsertFromDate,
}) {}
